import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import {
  resourceAllocationApi,
  ResourceAllocation,
  ResourceAllocationFilters,
} from '@/lib/api/reports';

export function useResourceAllocation(filters: ResourceAllocationFilters) {
  const [data, setData] = useState<ResourceAllocation | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { startDate, endDate, groupId } = filters;

  const load = useCallback(async () => {
    setIsLoading(true);
    try {
      setData(await resourceAllocationApi.get({ startDate, endDate, groupId }));
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Erro ao carregar a alocação de recursos');
    } finally {
      setIsLoading(false);
    }
  }, [startDate, endDate, groupId]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, isLoading, reload: load };
}
